"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { reviewKeys } from "@/features/reviews/shared/keys";
import type { CreateReviewData } from "@/features/reviews/shared/types";

export function useSubmitReview() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreateReviewData) => {
      const response = await fetch("/api/reviews", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.code || "FAILED_TO_SUBMIT");
      }

      return response.json();
    },
    onSuccess: (_, variables) => {
      // Invalidate reviews list for this product
      queryClient.invalidateQueries({
        queryKey: reviewKeys.lists(),
      });
      // Invalidate canReview check
      queryClient.invalidateQueries({
        queryKey: reviewKeys.canReview(variables.productId),
      });
    },
  });
}
